<!-- <div class="wrapper ltr main-body leftmenu bgcolor2"> -->

  <body class="ltr main-body leftmenu ">
    <div class="main-content side-content pt-0 ml-0">
      <div class="main-container container-fluid">
        <div class="inner-body">
          <div class="main-panel">
            <div class="content">
              <div class="margin_top">
                <div class="col-sm-12">
                  <div class="row row-sm add-form">
                    <div class="card custom-card">
                      <mat-tab-group (selectedTabChange)="onTabChanged($event)" class="mat-tab-labels"
                        [selectedIndex]="selectedIndex ">
                        <!-- [ngClass]="checkcolor('Personal Details')"  -->
                        <mat-tab [ngClass]="checkcolor('Personal Details','mat-tab-label-0-0')" label="Personal Details">
                          <app-personal-details [tabName]="selectedTabName" (next)="next()" *ngIf="selectedIndex == 0" ></app-personal-details>
                        </mat-tab>
                        <mat-tab [ngClass]="checkcolor('Contact Details','mat-tab-label-0-1')" label="Contact Details"
                          [disabled]="umsService.studentProgressList['StudentAddress'] == 1">
                          <app-contact-details [tabName]="selectedTabName" (next)="next()" (prev)="prev()" *ngIf="selectedIndex == 1" ></app-contact-details>
                        </mat-tab>
                        <mat-tab [ngClass]="checkcolor('Reservations Details','mat-tab-label-0-2')"
                          label="Reservations Details" [disabled]="umsService.studentProgressList['StudentReservation'] == 1">
                          <app-reservations-details [tabName]="selectedTabName" (prev)="prev()" (next)="next()" *ngIf="selectedIndex == 2" ></app-reservations-details>
                        </mat-tab>
                        <mat-tab [ngClass]="checkcolor('Additional Details','mat-tab-label-0-3')"
                          label="Additional Details" [disabled]="umsService.studentProgressList['StudentAdditionalDetails'] == 1">
                          <app-additional-details [tabName]="selectedTabName" (prev)="prev()" (next)="next()" *ngIf="selectedIndex == 3" ></app-additional-details>
                        </mat-tab>
                        <mat-tab [ngClass]="checkcolor('Qualification Details','mat-tab-label-0-4')"
                          label="Qualification Details" [disabled]="umsService.studentProgressList['StudentQualification'] == 1">
                          <app-qualification-details [tabName]="selectedTabName" (prev)="prev()" (next)="next()" *ngIf="selectedIndex == 4" ></app-qualification-details>
                        </mat-tab>
                        <mat-tab [ngClass]="checkcolor('Photo & Signatur','mat-tab-label-0-5')" label="Photo & Signature"
                        [disabled]="umsService.studentProgressList['StudentPhotoAndSign'] == 1">
                          <app-photo-signature-details [tabName]="selectedTabName" (prev)="prev()" (next)="next()" *ngIf="selectedIndex == 5" ></app-photo-signature-details>
                        </mat-tab>
                        <mat-tab [ngClass]="checkcolor('Admission Details','mat-tab-label-0-6')" label="Admission Details"
                        [disabled]="umsService.studentProgressList['StudentAdmissinDetails'] == 1">
                          <app-admission-details [tabName]="selectedTabName" (next)="next()" (prev)="prev()" *ngIf="selectedIndex == 6" ></app-admission-details>
                        </mat-tab>
                        <mat-tab [ngClass]="checkcolor('Document Upload','mat-tab-label-0-7')" label="Document Upload"
                        [disabled]="umsService.studentProgressList['StudentuploadDocument'] == 1">
                          <app-document-details [tabName]="selectedTabName" (prev)="prev()" (first)="first()" *ngIf="selectedIndex == 7" ></app-document-details>
                        </mat-tab>
                      </mat-tab-group>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </body>